module.exports = __webpack_public_path__ + "static/media/intuitive-tune-tools.6ff39de2.png";